<template>
  <div class="login__ls primary">
      <div class="login__logo-intro">
        <router-link to="/">
          <img src="@/assets/cia_logo_white.svg" alt="CIA" class="mb-5">
        </router-link>
      </div>
      <div class="login__intro">
        <p class="display-2">
          Centrum Innowacyjnej<br/>Archiwizacji w Katowicach
        </p>
        <p class="display-1">Wirtualne repozytorium zasobów multimedialnych</p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'sidebar',
};
</script>
